/**
 * @desc 修改挂牌商品
 */
import { ListingEntity, ListingForm } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type UpdateListingParameter = ListingForm

const method = 'PUT'
const url = '/trade/member/listing'

export const updateListingApi = (
  data?: UpdateListingParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<ListingEntity>({
    method,
    url,
    data,
    ...config
  })
}

updateListingApi.method = method
updateListingApi.url = url
